import React, { Component } from "react";

// Images import
import serachIcon from "../assets/images/search.svg";
import lock from "../assets/images/lock.svg";
import delet from "../assets/images/delet.svg";
import cloud from "../assets/images/cloud.svg";
import lockIcon from "../assets/images/lock-icon.svg";
import reStoreIcon from "../assets/images/restore.png";
import axios from 'axios';
import _ from 'lodash';
import { Link } from 'react-router-dom'

//Service import
import service from '../services'

//Loader import
import Loader from "../component/loader";

//react-paginate import 
import ReactPaginate from "react-paginate";

//sweet alert
import swal from 'sweetalert';

//moment import 
import moment from 'moment-timezone'

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'

import Cookies from 'universal-cookie';
import ShareIcon from "../icons/ShareIcon";
import LockIcon from "../icons/LockIcon";
import LockCloseIcon from "../icons/LockCloseIcon";
import ReceiptModal from "./ReceiptModal";
import ErrorPopUp from "./errorPopUp";
import ManageMembershipModel from "./ManageMembershipModel";
import TextField from './TextField'
import DatePicker from 'react-datepicker'
import CalendarIcon from '../icons/calendaricon'
import SyncIcon from "../icons/SyncIcon";
import RoleResetPopup from "./RoleResetPopup";
import { ADMIN_ROLE } from "../cosntants";

let roleWiseFilterData = [];
let sub;

const mapStateToProps = state => ({
    getLoginRole: state.getLoginRole,
    getLoginUser: state.getLoginUser,
    profileName: state.profileName
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

const cookies = new Cookies();

class superAdminUserMgnt extends Component {

    constructor(props) {
        super(props)

        this.state = {
            searchField: '',
            getAllUserMgnt: [],
            purchaseList: [],
            isSync: false,
            syncId: null,
            isBlocked: false,
            errorPopup: false,
            roleResetPopup: false,
            resendMailPopup: false,
            emailLoader: false,
            userForResendMail: [],
            AddRemove: false,
            MailSendPopup: false,
            viewUserList:false,
            rolesType: [
                { assign: "All", name: "All", value: true },
                { assign: "sioUser", name: "Industry", value: false },
                { assign: "pressUser", name: "Press", value: false },
                { assign: 'generalUser', name: 'General', value: false },
                { assign: 'circleGuestUser', name: 'Sundance Guest', value: false },
            ],
            // pagination variable diclaration start
            offset: 1,
            perPage: 50,
            currentPage: 0,
            defaultUser: {},
            messageModal:{
                flag: false,
                message: ""
            },
            openUserFilter:false,
            fromDate: new Date(),
            toDate: new Date(),
            // pagination variable diclaration end
            userHistoryModal: false,
            selectedHistoryUser: null,
        }
        this.apiserve = new service();
        this.servicesValue = _.debounce(this.servicesValue, 1500);
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        roleWiseFilterData = [];
        this.setState({getAllUserMgnt:[]})
    }

    componentDidMount = async () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|getAllFestivalUser":
                    if (!response.error) {
                        this.setState({
                            getAllUserMgnt: response.data.docs,
                            getTotalDocs: response.data.totalDocs,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                        }, () => {
                            this.setState({ loaderFlag: false })
                        })
                    }
                    break;
                case "email|send":
                    if (!response.error) {
                        this.apiserve.success('Email sent!')
                        this.setState({
                            resendMailPopup: false,
                            MailSendPopup: false,
                            emailLoader: false,
                            userForResendMail: []
                        })
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "deleteUser":
                    var data = {}
                    if (this.state.searchField.length) {
                        data.filter = this.state.searchField
                    }
                    if (roleWiseFilterData && roleWiseFilterData.length) {
                        data.role = roleWiseFilterData
                    }

                    data.page = 1
                    data.limit = 50
                    data.isDeleted = this.state.viewUserList
                    this.apiserve.sendevent("admin|getAllFestivalUser", data);
                    break;
                case "admin|convertUser":
                    var data = {}
                    if (this.state.searchField.length) {
                        data.filter = this.state.searchField
                    }
                    if (roleWiseFilterData && roleWiseFilterData.length) {
                        data.role = roleWiseFilterData
                    }

                    data.page = 1
                    data.limit = 50
                    data.isDeleted = this.state.viewUserList
                    this.apiserve.sendevent("admin|getAllFestivalUser", data);
                    break;
                case "restoreUser":
                    var data = {}
                    if(response.error){
                        swal(response.data, {
                            icon: "error"
                        });
                    } else {
                        swal(response.data, {
                            icon: "success"
                        });
                        if (this.state.searchField.length) {
                            data.filter = this.state.searchField
                        }
                        if (roleWiseFilterData && roleWiseFilterData.length) {
                            data.role = roleWiseFilterData
                        }
    
                        data.page = 1
                        data.limit = 50
                        data.isDeleted = this.state.viewUserList
                        this.apiserve.sendevent("admin|getAllFestivalUser", data);
                    }
                    break;
                case "user|syncLibrary" : 
                    if(!response.error && response.data.success){
                        this.setState({
                            messageModal:{
                                flag: true,
                                message: " Synchronization Successfully!"},
                        }, () => {
                            this.setState({ 
                                isSync:  false
                            })
                        })
                    }
                break; 
                case "blockUser":
                    var data = {}
                    if (this.state.searchField.length) {
                        data.filter = this.state.searchField
                    }
                    if (roleWiseFilterData && roleWiseFilterData.length) {
                        data.role = roleWiseFilterData
                    }

                    data.page = 1
                    data.isDeleted = this.state.viewUserList
                    data.limit = 50
                    this.apiserve.sendevent("admin|getAllFestivalUser", data);
                    break;
                case "admin|updateRoleUser":
                    var data = {}
                    if (this.state.searchField.length) {
                        data.filter = this.state.searchField
                    }
                    if (roleWiseFilterData && roleWiseFilterData.length) {
                        data.role = roleWiseFilterData
                    }

                    data.page = 1
                    data.isDeleted = this.state.viewUserList
                    data.limit = 50
                    this.apiserve.sendevent("admin|getAllFestivalUser", data);
                    break;
                case "loginUser":
                    if (!response.error) {
                        if(cookies.get(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "myEventiveLoginToken" : 'myEventiveLoginToken')){
                            cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "myEventiveLoginToken" : "myEventiveLoginToken", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                            window.Eventive.logout()
                        }
                        let data = {
                            fname: response.data.userData.fname,
                            lname: response.data.userData.lname,
                            image: response.data.userData.image,
                            showMyLibrary: response.data.showMyLibrary || false,
                            userRole:response.data.userData.additionalRoles,
                            userId: response.data.user._id,
                            token: response.data.token,
                            email: response.data.email,
                            isSundanceCircle: response.data.user.isSundanceCircle,
                            userRoleFormatted: this.getRoleString(response.data.userData.additionalRoles)
                        }
                        document.cookie = (!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser") + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                        cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                        cookies.set(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "STYXKEY_sundanceUser" : "STYXKEY_sundanceUser", data, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/", secure: true })
                        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_GENERAL)
                    }
                    break;
                case "generalUser|generalUserGostLogin":
                    if (!response.error) {
                        if(cookies.get(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'myEventiveLoginToken' : 'myEventiveLoginToken')){
                            cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "myEventiveLoginToken" : "myEventiveLoginToken", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                            window.Eventive.logout()
                        } 
                        if (!response && response.data && response.data.user && (response.data.user.role === 'sioUser' || response.data.user.role === 'pressUser' || response.data.user.role === "circleGuestUser" || response.data.user.role === "artistUser")) {
                            let data = {
                                fname: response.data.userData.fname,
                                lname: response.data.userData.lname,
                                image: response.data.userData.image,
                                showMyLibrary: response.data.showMyLibrary || false,
                                userRole:response.data.userData.additionalRoles,
                                userId: response.data.user._id,
                                token: response.data.token,
                                email: response.data.email,
                                userRoleFormatted: this.getRoleString(response.data.userData.additionalRoles)
                            }
                            document.cookie = (!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser") + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                            cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                            cookies.set(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser", data, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/",secure: true })
                            window.open(process.env.REACT_APP_FRONTEND_ORIGIN_GENERAL)
                        } else if (response && response.data && response.data.user && response.data.user.role === 'generalUser') {
                            let data = {
                                fname: response.data.userData.fname,
                                lname: response.data.userData.lname,
                                image: response.data.userData.image,
                                showMyLibrary: response.data.showMyLibrary || false,
                                userRole:response.data.userData.additionalRoles,
                                userId: response.data.user._id,
                                token: response.data.token,
                                email: response.data.email,
                                userRoleFormatted: this.getRoleString(response.data.userData.additionalRoles)
                            }
                            document.cookie = (!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser") + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                            cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                            cookies.set(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'STYXKEY_sundanceUser' : "STYXKEY_sundanceUser", data, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/",secure: true })
                            window.open(process.env.REACT_APP_FRONTEND_ORIGIN_GENERAL)
                        }
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case "admin|getPurchaseHistory":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            purchasereceipt: true,
                            purchaseList: response.data
                        })
                    } else {
                        this.setState({ loaderFlag: false })
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "generalUser|generalUser_email_send":
                    if (!response.error) {
                        this.apiserve.success('Email sent!')
                        this.setState({
                            resendMailPopup: false,
                            emailLoader: false,
                            MailSendPopup: false,
                            userForResendMail: []
                        })
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "email|sendLinkToPrompt":
                    if (!response.error) {
                        this.setState({
                            resendMailPopup: true,
                            mailLink: response ?.data ?.mailLink ?.registerRef,
                            loginLink: response ?.data ?.mailLink ?.loginLink,
                        })
                    }
                    break;
                case 'admin|getAllFestivalUserCount':
                    if(!response.error){
                        this.setState({loaderFlag:false,openUserFilter:false})
                        window.open(response.data.location,'_self')
                    }
                default:
                    break;
            }
        });


        this.getAllUserMgntFn(this.state.offset, this.state.perPage);
        this.setState({
            loaderFlag: true,
        });
    }

    getAllUserMgntFn = (skip, limit, searchField, roleWiseFilterData) => {
        var data = {}
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        if (roleWiseFilterData && roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        data.page = skip
        data.isDeleted = this.state.viewUserList
        data.limit = limit
        this.apiserve.sendevent("admin|getAllFestivalUser", data);
    }

    sendEmailPopup = (user) => {
        let data = {
            userId: user._id
        }

        if (user.status === "invited") {
            this.apiserve.sendevent("email|sendLinkToPrompt", data);
        } else if (user.role === 'generalUser') {
            this.apiserve.sendevent("generalUser|generalUser_email_send", data)
        }
        else {
            this.setState({
                MailSendPopup: true
            })
        }
        this.setState({
            userForResendMail: user
        })
    }
    deleteAdminUser = (item) => {

        swal({
            title: "Are you sure?",
            text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    if (item.orderCount) {
                        this.setState({
                            errorPopup: true,
                            errorMsg: `This user already has one or more items in My Purchases and can't be deleted`
                        })
                    } else {
                        swal("Your record has been deleted!", {
                            icon: "success"
                        });
                        let data = {
                            id: item._id
                        }
                        this.apiserve.sendevent("deleteUser", data);
                    }
                } else {
                    swal("Your record is safe!");
                }
            });
    }
    removeRole = (item) => {
        this.setState({roleResetPopup:true, currentUser:item})
    }
    removeuserRole = (user, role) => {
        let data = {
            userId: user._id,
            additionalRoles: role
        }
        this.apiserve.sendevent("admin|updateRoleUser", data);
        this.setState({roleResetPopup:false, currentUser:{}})
    }
    resetRole = (item) => {
        swal({
            title: "Are you sure?",
            text: "You are about to reset this user to a general role type",
            icon: "warning",
            buttons: [  "No", "Yes"],
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {
                if (item.orderCount) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: `This user already has one or more items in My Purchases and can't be deleted`
                    })
                } else {
                    swal("Your user has been reset to a general role type!", {
                        icon: "success"
                    });
                    let data = {
                        userId: item._id
                    }
                    this.apiserve.sendevent("admin|convertUser", data);
                }
            } else {
                swal("Your user is safe!");
            }
        });
    }
    restoreUser = (item) => {

        swal({
            title: "Are you sure?",
            text: "You want to restore this user",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    if (item.orderCount) {
                        this.setState({
                            errorPopup: true,
                            errorMsg: `This user already has one or more items in My Purchases and can't be deleted`
                        })
                    } else {
                        let data = {
                            id: item._id
                        }
                        this.apiserve.sendevent("restoreUser", data);
                    }
                } else {
                    swal("Your user is safe!");
                }
            });
    }

    syncUser = (userId) => {
        this.setState({isSync:true, syncId:userId})
        var data = { userId: userId, }
        this.apiserve.sendevent("user|syncLibrary", data);
    }

    blockAdminUser = async (item) => {
        swal({
            title: "Are you sure?",
            text: "You want to block this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willBlock) => {
                if (willBlock) {
                    swal("Your record has been blocked!", {
                        icon: "success"
                    });
                    let data = {
                        id: item._id,
                        isBlocked: true
                    }
                    this.apiserve.sendevent("blockUser", data);
                } else {
                    swal("Your record is unblocked!");
                }
            });
    }

    unblockAdminUser = async (item) => {
        swal({
            title: "Are you sure?",
            text: "You want to unblock this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willBlock) => {
                if (willBlock) {
                    swal("Your record has been unblock!", {
                        icon: "success"
                    });
                    let data = {
                        id: item._id,
                        isBlocked: false
                    }
                    this.apiserve.sendevent("blockUser", data);
                } else {
                    swal("Your record is block!");
                }
            });
    }

    //Pagination Click
    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true
            },
            () => {
                this.getAllUserMgntFn(offset, this.state.perPage, this.state.searchField, roleWiseFilterData);
            }
        );
    };

    //role wise filter
    roleWiseFilter = (e, selectedInex) => {

        let index = selectedInex
        let event = e.target.checked

        let roleArray = [...this.state.rolesType]
        roleArray.forEach((key, i) => {
            if (index === 0) {
                if (i === 0) {
                    roleArray[index].value = event
                } else {
                    roleArray[i].value = false
                }
            } else {
                if (i === 0) {
                    if (roleWiseFilterData && roleWiseFilterData.length === 1 && !event) {
                        roleArray[i].value = true
                    } else {
                        roleArray[i].value = false
                    }
                } else {
                    roleArray[index].value = event
                }
            }

        });
        this.setState({
            ...this.state,
            rolesType: roleArray,
            currentPage: 0
        }, () => {
            if (index === 0 && event) {
                roleWiseFilterData = []
            } else if (event) {
                roleWiseFilterData = [...roleWiseFilterData, this.state.rolesType[index].assign];
            } else {
                let tempArray = roleWiseFilterData.filter((d) => d !== this.state.rolesType[index].assign);
                roleWiseFilterData = tempArray;
            }

            this.getAllAdminRoleFilter(this.state.offset, this.state.perPage);
        })
    };

    getAllAdminRoleFilter = (skip, limit) => {
        this.setState({ loaderFlag: true })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        data.page = 1
        data.isDeleted = this.state.viewUserList
        data.limit = 50
        this.apiserve.sendevent("admin|getAllFestivalUser", data);
    }

    servicesValue = () => {
        var data = {
            page: 1,
            limit: 50,
            isDeleted : this.state.viewUserList,
            filter: this.state.searchField,
        }
        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }
        if(this.state.searchField === '') delete data['filter'] 
        this.apiserve.sendevent("admin|getAllFestivalUser", data);
    }

    //Search Data
    onSearchFilter = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            currentPage: 0
        })
        this.servicesValue();
    }

    getCSVData = () => {
        this.setState({
            loaderFlag: true
        })
        let token = localStorage.getItem("loginToken")
        axios({
            url: process.env.REACT_APP_SOCKET_API_KEY + 'api/getUserList',
            method: 'get',
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then(res => {
                let csvContent = "data:text/csv;charset=utf-8,"
                    + res.data;
                var encodedUri = encodeURI(csvContent);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "userManagement.csv");
                document.body.appendChild(link);

                link.click()
                this.setState({
                    loaderFlag: false
                })
            })
            .catch(err => {
            })
    }

    loginUser = (userId, verified) => {
        if (verified) {
            let data = {
                id: userId
            }
            this.apiserve.sendevent("loginUser", data);
        }else{
            this.apiserve.error('user is not verified')
        }
    }

    loginUserGeneral = (userId, verified) => {
        if (verified) {
            let data = {
                id: userId,
                role: "generalUser",
            }
            this.apiserve.sendevent("generalUser|generalUserGostLogin", data);
        }else{
            this.apiserve.error('user is not verified')
        }
    }

    CopyLinkAddress = (copy) => {
        if (copy) {
            navigator.clipboard.writeText(copy);
            this.setState({
                copylinkflag: true,
                copyiconflag: true
            })
            setTimeout(() => {
                this.setState({
                    copyiconflag: false
                })
            }, 2000);
        }
        else {


        }


    }
    
    getDisplayValue = (accNo) => {
        const { profileName } = this.props;
        let accessValue = profileName.CMA.find(_ => _.access === accNo);
        return accessValue ? accessValue.value : false;
    }

    getUserMgntTableHeadView = () => {
        const { rolesType } = this.state
        return (
            <tr>
                <th className="user_email_d">Email</th>
                <th className="user_firstName_d">First Name</th>
                <th className="user_lastName_d">Last Name</th>
                <th className="depart_d">
                    <span className="d_flex d_flex_align_center">
                        Role
                      {roleWiseFilterData && roleWiseFilterData.length ?
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: "7px" }}>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 12.5C6 12.3674 6.05268 12.2402 6.14645 12.1464C6.24021 12.0527 6.36739 12 6.5 12H9.5C9.63261 12 9.75979 12.0527 9.85355 12.1464C9.94732 12.2402 10 12.3674 10 12.5C10 12.6326 9.94732 12.7598 9.85355 12.8536C9.75979 12.9473 9.63261 13 9.5 13H6.5C6.36739 13 6.24021 12.9473 6.14645 12.8536C6.05268 12.7598 6 12.6326 6 12.5ZM4 9.5C4 9.36739 4.05268 9.24021 4.14645 9.14645C4.24021 9.05268 4.36739 9 4.5 9H11.5C11.6326 9 11.7598 9.05268 11.8536 9.14645C11.9473 9.24021 12 9.36739 12 9.5C12 9.63261 11.9473 9.75979 11.8536 9.85355C11.7598 9.94732 11.6326 10 11.5 10H4.5C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5ZM2 6.5C2 6.36739 2.05268 6.24021 2.14645 6.14645C2.24021 6.05268 2.36739 6 2.5 6H13.5C13.6326 6 13.7598 6.05268 13.8536 6.14645C13.9473 6.24021 14 6.36739 14 6.5C14 6.63261 13.9473 6.75979 13.8536 6.85355C13.7598 6.94732 13.6326 7 13.5 7H2.5C2.36739 7 2.24021 6.94732 2.14645 6.85355C2.05268 6.75979 2 6.63261 2 6.5Z" fill="black" />
                                <circle cx="8" cy="2" r="2" fill="black" />
                            </svg>
                            :
                            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: "7px" }}>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6.5C4 6.36739 4.05268 6.24021 4.14645 6.14645C4.24021 6.05268 4.36739 6 4.5 6H7.5C7.63261 6 7.75979 6.05268 7.85355 6.14645C7.94732 6.24021 8 6.36739 8 6.5C8 6.63261 7.94732 6.75979 7.85355 6.85355C7.75979 6.94732 7.63261 7 7.5 7H4.5C4.36739 7 4.24021 6.94732 4.14645 6.85355C4.05268 6.75979 4 6.63261 4 6.5ZM2 3.5C2 3.36739 2.05268 3.24021 2.14645 3.14645C2.24021 3.05268 2.36739 3 2.5 3H9.5C9.63261 3 9.75979 3.05268 9.85355 3.14645C9.94732 3.24021 10 3.36739 10 3.5C10 3.63261 9.94732 3.75979 9.85355 3.85355C9.75979 3.94732 9.63261 4 9.5 4H2.5C2.36739 4 2.24021 3.94732 2.14645 3.85355C2.05268 3.75979 2 3.63261 2 3.5ZM0 0.5C0 0.367392 0.0526785 0.240215 0.146447 0.146447C0.240215 0.0526785 0.367392 0 0.5 0H11.5C11.6326 0 11.7598 0.0526785 11.8536 0.146447C11.9473 0.240215 12 0.367392 12 0.5C12 0.632608 11.9473 0.759785 11.8536 0.853553C11.7598 0.947321 11.6326 1 11.5 1H0.5C0.367392 1 0.240215 0.947321 0.146447 0.853553C0.0526785 0.759785 0 0.632608 0 0.5Z" fill="black" />
                            </svg>
                        }
                    </span>
                    <div className="tabelData_popup">
                        <form>
                            <div className="customCheck">
                                {rolesType.map((item, i) => (
                                    <div className="customCheckBox">
                                        <input
                                            type="checkbox"
                                            id={item.name}
                                            name={item.name}
                                            value={item.value ? true : false}
                                            checked={item.value ? true : false}
                                            onClick={(e) => this.roleWiseFilter(e, i)}
                                        />
                                        <label htmlFor={item.name}>{item.name}</label>
                                    </div>
                                ))}
                            </div>
                        </form>
                    </div></th>
                <th className="user_login_d">Last Logged On (MT)</th>
                <th className="user_regOn_d">Registered On (MT)</th>
                <th className="icon_d"></th>
            </tr>
        )
    }

    getDisplayValue = (accNo) => {
        const { profileName } = this.props;
        let accessValue = profileName.CMA.find(_ => _.access === accNo);
        return accessValue ? accessValue.value : false;
    }

    getRoleString = (additionalRoles) => {
        let roles = additionalRoles.filter(role => !ADMIN_ROLE.map(adminRole => adminRole.value).includes(role));
        const roleMap = {
            generalUser: 'General',
            circleGuestUser: 'Sundance Guest',
            sioUser: 'Industry',
            pressUser: 'Press',
            circleUser: 'Sundance Circle',
            artistUser: 'Artist',
            pafUser: 'PAF User'
        };

        roles = roles.filter(role => roleMap[role]).map(role => roleMap[role]);
        if (roles.length > 0) {
            if (roles.length === 1) return roles[0];
            if (roles.length === 2) return roles.join(' & ');
            return roles.slice(0, -1).join(', ') + ' & ' + roles[roles.length - 1];
        } else  {
            return 'General';
        }
    };

    getUserMgntTableBodyView = () => {
        const { getAllUserMgnt,isSync,syncId } = this.state
        var userRole = localStorage.getItem('currentUserRole') ? localStorage.getItem('currentUserRole') : this.props.getLoginRole.user.role
        const { profileName } = this.props

        return (
            getAllUserMgnt.map((item, index) => {
                let lastLogin = `${moment(item.lastLogin).tz("US/Mountain").format('MM/DD/YYYY')}  ${moment(item.lastLogin).tz("US/Mountain").format('h:mm A')}`;
                let createdAt = `${moment(item.createdAt).tz("US/Mountain").format('MM/DD/YYYY')}  ${moment(item.createdAt).tz("US/Mountain").format('h:mm A')}`;
                return (
                    <tr>
                        <td className="email_d">{item.email}</td>
                        <td className="firstName_d">{item.fname}</td>
                        <td className="lastName_d">{item.lname}</td>
                        <td className="depart_d">{this.getRoleString(item.additionalRoles)} </td>
                        <td className="regOn_d">{item.lastLogin ? lastLogin : '-'}</td>
                        <td className="regOn_d">{item.createdAt ? createdAt : '-'}</td>
                        <td className="icon_d ">
                            {!this.state.viewUserList ? 
                            <>
                                {(userRole === 'admin' || (item.additionalRoles || []).includes(
                                    userRole === 'sundanceCircle' ? 'circleUser' :
                                    userRole === 'sundanceGuest' ? 'circleGuestUser' :
                                    userRole + 'User'
                                )) && (
                                    <Link onClick={() => this.openUserHistory(item)}>
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7.65625 10.0625H6.34375V6.34375H7.65625V10.0625ZM7.65625 5.03125H6.34375V3.71875H7.65625V5.03125Z" fill="#5D737E"/>
                                        </svg>
                                        <div style={{width:'140px', left:'-64px', top:'-44px'}}>View User History & Information</div>
                                    </Link>
                                )}
                                {(userRole !== 'admin' || item.additionalRoles.length === 0 || (item.additionalRoles.filter(role => !ADMIN_ROLE.map(adminRole => adminRole.value).includes(role)).length === 1 && item.additionalRoles.includes('pafUser')) || item.additionalRoles.filter(role => !ADMIN_ROLE.map(adminRole => adminRole.value).includes(role)).length === 0) ? '' :  <Link onClick={() => this.removeRole(item)}>
                                    <img src="/images/undo.png"  alt="revert"/><div style={{width:'75px'}}>Remove Role</div>
                                </Link>}
                                <Link onClick={this.purchaseReceipt.bind(this, item.eventiveId)}>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7.34844 10.3938L7.35156 10.8891C7.35156 10.9578 7.29531 11.0156 7.22656 11.0156H6.78281C6.71406 11.0156 6.65781 10.9594 6.65781 10.8906V10.4C5.27031 10.2969 4.61719 9.50625 4.54688 8.64688C4.54063 8.57344 4.59844 8.51094 4.67188 8.51094H5.39375C5.45469 8.51094 5.50781 8.55469 5.51719 8.61406C5.59688 9.10938 5.98281 9.47969 6.675 9.57187V7.34219L6.28906 7.24375C5.47188 7.04844 4.69375 6.53906 4.69375 5.48281C4.69375 4.34375 5.55937 3.73125 6.66563 3.62344V3.10781C6.66563 3.03906 6.72188 2.98281 6.79063 2.98281H7.22969C7.29844 2.98281 7.35469 3.03906 7.35469 3.10781V3.61875C8.425 3.72656 9.22812 4.35156 9.32187 5.325C9.32969 5.39844 9.27187 5.4625 9.19687 5.4625H8.49531C8.43281 5.4625 8.37969 5.41563 8.37187 5.35469C8.30937 4.89844 7.94375 4.52656 7.34844 4.44531V6.54375L7.74531 6.63594C8.75781 6.88594 9.44687 7.37031 9.44687 8.45469C9.44687 9.63125 8.57187 10.2875 7.34844 10.3938ZM5.66563 5.41094C5.66563 5.80781 5.91094 6.11562 6.43906 6.30625C6.5125 6.33594 6.58594 6.35938 6.67344 6.38438V4.44688C6.09688 4.52031 5.66563 4.84375 5.66563 5.41094ZM7.48594 7.52344C7.44219 7.51406 7.39844 7.50312 7.34844 7.48906V9.57812C8.01406 9.51875 8.47344 9.15312 8.47344 8.54062C8.47344 8.06094 8.225 7.74844 7.48594 7.52344Z" fill="#5D737E" />
                                    </svg>
                                    <div style={{top:'-43px'}}>Purchase History</div>
                                </Link>
                            
                                {profileName && profileName.role === 'admin' ? 
                                    isSync &&
                                        item._id === syncId ?
                                        <Link>
                                            <img src="/images/icons8-refresh.gif"  alt="gif" style={{width:"12px"}} />
                                        </Link>
                                    :                     
                                        <Link  onClick={() => this.syncUser(item._id)}>
                                            <SyncIcon/> <div>sync</div>
                                        </Link>
                                : ''}

                                {item.isBlocked ?
                                    <Link onClick={() => this.unblockAdminUser(item)} className="lock_icon">
                                        <LockCloseIcon /><div>unblock</div>
                                    </Link>
                                    :
                                    <Link onClick={() => this.blockAdminUser(item)}>
                                        <LockIcon /><div>block</div>
                                    </Link>
                                }

                                {userRole === 'admin' ? <Link onClick={() => this.deleteAdminUser(item)}>
                                    <img src={delet} /><div>delete</div>
                                </Link> : ''}
                                <Link onClick={(item.role === 'generalUser' && item.additionalRoles.length === 0) ? this.loginUserGeneral.bind(this, item._id, item.verified) : this.loginUser.bind(this, item._id, item.verified)}><ShareIcon /></Link>
                                {userRole === 'admin' ? ''
                                    : <label className="check_admin" onClick={this.sendEmailPopup.bind(this, item)}>
                                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                        </svg>
                                        <span className="tooltip_box">Send invitation email</span>
                                    </label>
                                }
                            </>
                            : 
                                <Link onClick={() => this.restoreUser(item)} className="resotre_icon">
                                    <img src={reStoreIcon} /><div>Restore</div>
                                </Link>
                            }   
                            

                        </td>
                    </tr>
                )
            }))
    }

    purchaseReceipt = (eventiveId) => {
        this.setState({
            loaderFlag: true,
            currentEventiveId: eventiveId,
        })
        var data = {
            userEventiveId: eventiveId
        }
        this.apiserve.sendevent("admin|getPurchaseHistory", data)
    }

    manageMembershipModel = (userDetail) => {
        this.setState({
            membership: !this.state.membership,
            clickUserMembership: userDetail
        })
    }

    CloseModal = () => {
        this.setState({
            purchasereceipt: false,
            resendMailPopup: false,
            membership: false,
            AddRemove: false,
            copylinkflag: false,
            MailSendPopup: false,
        })
    }

    ClosemessageModal = () => {
        this.setState({
            messageModal:{
                flag: false,
                message: ""},
        });
    };

    resendMail = () => {
        const Role = this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role
        var data = {
            userId: this.state.userForResendMail._id
        }
        this.setState({
            emailLoader: true
        })
        if (this.state.userForResendMail.role === 'generalUser') {
            this.apiserve.sendevent("generalUser|generalUser_email_send", data)
        }
        else {
            this.apiserve.sendevent("email|send", data)
        }

    }
    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }
    closeRoleResetPopup = () => {
        this.setState({
            roleResetPopup: false,
            currentUser: {}
        })
    }

    ClosemessageModal = () => {
        this.setState({
            messageModal:{
                flag: false,
                message: ""},
        });
    };

    openUserHistory = (user) => {
        this.setState({ userHistoryModal: true, selectedHistoryUser: user });
    }

    closeUserHistoryModal = () => {
        this.setState({ userHistoryModal: false, selectedHistoryUser: null });
    }

    onFilter = () => {
        this.setState({
            openUserFilter:true
        })
    }
    viewUser = () => {
        this.setState({
            viewUserList:!this.state.viewUserList
        })
        let data = {}
        data.page = 1
        data.isDeleted = !this.state.viewUserList
        data.limit = 50
        this.apiserve.sendevent("admin|getAllFestivalUser", data);
    }

    onCancleFilter = () => {
        this.setState({
            openUserFilter:false
        })
    }

    onChangeUserFilterForm = (date) => {
        this.setState({
            fromDate: date
        })
    }

    onChangeUserFilterTo = (date) => {
        this.setState({
            toDate: date
        })
    }

    getMTTime = (d) => {
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
        return moment(d).add(offDifference,'minutes').toISOString() 
    }

    userFilter = (from,to) => {
        this.setState({ loaderFlag: true})
        let data = {}
        let fromDate = new Date(from)
        let toDate = new Date(to)
        fromDate.setHours(0)
        fromDate.setMinutes(0)
        toDate.setHours(23)
        toDate.setMinutes(59)
        data.startDate = this.getMTTime(fromDate)
        data.endDate = this.getMTTime(toDate)
        console.log('data:::',data);
        this.apiserve.sendevent('admin|getAllFestivalUserCount',data)
    }

    render() {
        const { getAllUserMgnt, getTotalDocs } = this.state
        const { getLoginRole } = this.props
        console.log(getLoginRole,"getLoginRole");
        let userRole = localStorage.getItem('currentUserRole') ? localStorage.getItem('currentUserRole') : getLoginRole.user.role
        return (
            <React.Fragment>
                <div className="right_side_wrapper adminUserMgnt_wrapper">
                    <div className="dashboard_header">
                        <div className="searchBlock">
                            <span>All Users ({getTotalDocs})</span>
                            <form onSubmit={e => { e.preventDefault(); }}>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    id="searchField"
                                    name="searchField"
                                    value={this.state.searchField}
                                    onChange={this.onSearchFilter} />
                                <button type='button' style={{ pointerEvents: 'none' }}>
                                    <img src={serachIcon} />
                                </button>
                            </form>
                        </div>
                        <div className="d_flex d_flex_align_center">
                        <div className=" mr_10">
                                <Link onClick={() => this.viewUser()} className="sd_viewuser_link">
                                    <span className="mr_5">{this.state.viewUserList ? 'View All Users' : 'View Delete User'}</span> 
                                </Link>
                            </div>
                            <div className="button_block FPG_btn mr_10">
                                <Link onClick={() => this.onFilter()} className="head_btn btn_height">
                                    <span className="mr_5">New User</span>
                                    <div className="Lock">
                                        {<img src={cloud} />}
                                    </div>  
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard_data">
                        <div className="dashboard_data_table film_list_table striped_table">
                            <table>
                                <thead>
                                    {this.getUserMgntTableHeadView()}
                                </thead>
                                <tbody>
                                    {this.getUserMgntTableBodyView()}
                                </tbody>
                            </table>
                        </div>


                        {/* Pagination View Display */}

                        {getAllUserMgnt.length && getAllUserMgnt ? (
                            <div className="custom-pagination">
                                <ReactPaginate
                                    previousLabel={""}
                                    nextLabel={""}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={this.state.currentPage}
                                />
                            </div>
                        ) : (
                                ""
                            )}

                    </div>
                    {
                        this.state.purchasereceipt ? <ReceiptModal CloseModal={this.CloseModal} purchaseList={this.state.purchaseList && this.state.purchaseList.orders} role={getLoginRole && getLoginRole.user && getLoginRole.user.role} onRefresh={() => this.apiserve.sendevent("admin|getPurchaseHistory", { userEventiveId: this.state.currentEventiveId })} /> : ''
                    }
                    {this.state.membership ? <ManageMembershipModel CloseModal={this.CloseModal} clickUserMembership={this.state.clickUserMembership} /> : ""}
                    {this.state.loaderFlag ? (
                        <Loader />
                    ) : (
                            ""
                        )}

                    {this.state.loaderFlag ? (
                        <Loader />
                    ) : (
                            ""
                        )}

                    {this.state.errorPopup ?
                        <ErrorPopUp
                            errorMsg={this.state.errorMsg}
                            errorMsgPopup={this.errorMsgPopup}
                        />
                        : ''
                    }
                    {this.state.roleResetPopup ?
                        <RoleResetPopup
                            closeRoleResetPopup={this.closeRoleResetPopup}
                            user={this.state.currentUser}
                            updateRole={this.removeuserRole}
                        />
                        : ''
                    }

                    {this.state.messageModal.flag && (
                        <div className={`user_popup active`}>
                            <span className="popup_overlay"></span>
                            <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                                <div className="approve_popup_header text_center relative">
                                    {this.state.messageModal.message}
                                </div>
                                <div className="content">
                                    <div className="field_row text_center">
                                        <button className="small_btn active" onClick={this.ClosemessageModal}>OK</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {
                        this.state.openUserFilter ?
                            <div className='user_popup active'>
                                <span className="popup_overlay" onClick={this.onCancleFilter}></span>
                                <div className="sundance_popup_detail box_shadow approve_success_popup bg_white overflow_initial" >
                                    <div className="approve_popup_header text_center relative pb_0">
                                        <span className="close_popup" onClick={this.onCancleFilter}>
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.192 0.343994L5.949 4.58599L1.707 0.343994L0.292999 1.75799L4.535 5.99999L0.292999 10.242L1.707 11.656L5.949 7.41399L10.192 11.656L11.606 10.242L7.364 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                            </svg>
                                        </span>
                                        <h3 className="mb_10">Select Date Filter { }</h3>
                                    </div>
                                    <div className="content">
                                        <div className="date_content d_flex d_flex_justify_center">

                                            <div className="from_date d_flex d_flex_align_center d_flex_justify_center">
                                                <TextField type="text" name="countDownDate" label="From" disabled={true} value={moment(this.state.fromDate).format(
                                                    "MM/DD/YYYY"
                                                )}
                                                    placeholder="mm / dd / yyyy" />

                                                <div className=" ml_10 d_flex d_flex_align_center d_flex_justify_center">
                                                    <DatePicker
                                                        selected={this.state.fromDate}
                                                        onChange={(e) => this.onChangeUserFilterForm(e)}
                                                        placeholderText="mm / dd / yyyy"
                                                        maxDate={new Date()}

                                                        customInput={
                                                            <span className="calendar">
                                                                <CalendarIcon opacity="1" />
                                                            </span>
                                                        }

                                                    />
                                                </div>
                                            </div>
                                            <div className="to_date d_flex d_flex_justify_center">
                                                <TextField type="text" name="countDownDate" label="To" disabled={true} value={moment(this.state.toDate).format(
                                                    "MM/DD/YYYY"

                                                )} placeholder="mm / dd / yyyy" />


                                                <div className=" ml_10 d_flex d_flex_align_center d_flex_justify_center">
                                                    <DatePicker
                                                        selected={this.state.toDate}
                                                        onChange={(e) => this.onChangeUserFilterTo(e)}
                                                        maxDate={new Date()}
                                                        placeholderText="mm / dd / yyyy"
                                                        customInput={
                                                            <span className="calendar">
                                                                <CalendarIcon opacity="1" />
                                                            </span>
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="field_row text_center">
                                            <button className="active" onClick={(e) => this.userFilter(this.state.fromDate, this.state.toDate)}>Download CSV </button>
                                        </div>
                                    </div>
                                </div>
                            </div> : ''
                    }

                </div>
                <div className={`user_popup ${this.state.MailSendPopup ? "active" : ''}`}>
                    <span className="popup_overlay" onClick={this.CloseModal}></span>
                    <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                        <div className="approve_popup_header text_center relative">
                            <p>Do you want to send the email to {this.state.userForResendMail.fname + ' ' + this.state.userForResendMail.lname} again?</p>
                            <span className="close_popup" onClick={this.CloseModal}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                </svg>
                            </span>
                        </div>
                        <div className="content">
                            <div className="field_row text_center">
                                <button className="" onClick={this.CloseModal}>Cancel</button>
                                <button className="active" onClick={this.resendMail}>YES {this.state.emailLoader &&
                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Mail send 2 */}
                <div className={`user_popup ${this.state.resendMailPopup ? "active" : ''}`}>
                    <span className="popup_overlay" onClick={this.CloseModal}></span>
                    <div className="sundance_popup_detail box_shadow mailsend_popup bg_white">
                        <div className="approve_popup_header text_center relative">
                            <p> Get {this.state.userForResendMail.fname + ' ' + this.state.userForResendMail.lname + `'s`} Unique Registration Link:</p>
                            <span className="close_popup" onClick={this.CloseModal}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                </svg>
                            </span>
                        </div>
                        <div className="content">
                            <div>
                                <div className="copy_link d_flex d_flex_justify_spacebt d_flex_align_center">
                                    <h4 className="uppercase link_address">{this.state.mailLink ? this.state.mailLink : this.state.loginLink}</h4>
                                    <span className="pointer" onClick={() =>
                                        this.CopyLinkAddress(`${this.state.mailLink ? this.state.mailLink : this.state.loginLink}`)}>{!this.state.copyiconflag ?
                                            <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.5 8.43004C21.4878 8.32287 21.4644 8.21728 21.43 8.11504V8.01004C21.3739 7.89008 21.2991 7.77982 21.2083 7.68337L14.2083 0.683374C14.1119 0.592626 14.0016 0.517802 13.8817 0.461707C13.8468 0.456761 13.8115 0.456761 13.7767 0.461707C13.6582 0.393739 13.5273 0.350109 13.3917 0.333374H8.66667C7.73841 0.333374 6.84817 0.702123 6.19179 1.3585C5.53542 2.01488 5.16667 2.90512 5.16667 3.83337V5.00004H4C3.07174 5.00004 2.1815 5.36879 1.52513 6.02517C0.868749 6.68154 0.5 7.57178 0.5 8.50004V20.1667C0.5 21.095 0.868749 21.9852 1.52513 22.6416C2.1815 23.298 3.07174 23.6667 4 23.6667H13.3333C14.2616 23.6667 15.1518 23.298 15.8082 22.6416C16.4646 21.9852 16.8333 21.095 16.8333 20.1667V19H18C18.9283 19 19.8185 18.6313 20.4749 17.9749C21.1313 17.3185 21.5 16.4283 21.5 15.5V8.50004V8.43004ZM14.5 4.31171L17.5217 7.33337H15.6667C15.3572 7.33337 15.0605 7.21046 14.8417 6.99167C14.6229 6.77287 14.5 6.47613 14.5 6.16671V4.31171ZM14.5 20.1667C14.5 20.4761 14.3771 20.7729 14.1583 20.9917C13.9395 21.2105 13.6428 21.3334 13.3333 21.3334H4C3.69058 21.3334 3.39383 21.2105 3.17504 20.9917C2.95625 20.7729 2.83333 20.4761 2.83333 20.1667V8.50004C2.83333 8.19062 2.95625 7.89388 3.17504 7.67508C3.39383 7.45629 3.69058 7.33337 4 7.33337H5.16667V15.5C5.16667 16.4283 5.53542 17.3185 6.19179 17.9749C6.84817 18.6313 7.73841 19 8.66667 19H14.5V20.1667ZM19.1667 15.5C19.1667 15.8095 19.0438 16.1062 18.825 16.325C18.6062 16.5438 18.3094 16.6667 18 16.6667H8.66667C8.35725 16.6667 8.0605 16.5438 7.84171 16.325C7.62292 16.1062 7.5 15.8095 7.5 15.5V3.83337C7.5 3.52396 7.62292 3.22721 7.84171 3.00842C8.0605 2.78962 8.35725 2.66671 8.66667 2.66671H12.1667V6.16671C12.1667 7.09497 12.5354 7.9852 13.1918 8.64158C13.8482 9.29796 14.7384 9.66671 15.6667 9.66671H19.1667V15.5Z" fill="black" />
                                            </svg>
                                            :
                                            <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.5 8.43004C21.4878 8.32287 21.4644 8.21728 21.43 8.11504V8.01004C21.3739 7.89008 21.2991 7.77982 21.2083 7.68337L14.2083 0.683374C14.1119 0.592626 14.0016 0.517802 13.8817 0.461707C13.8468 0.456761 13.8115 0.456761 13.7767 0.461707C13.6582 0.393739 13.5273 0.350109 13.3917 0.333374H8.66667C7.73841 0.333374 6.84817 0.702123 6.19179 1.3585C5.53542 2.01488 5.16667 2.90512 5.16667 3.83337V5.00004H4C3.07174 5.00004 2.1815 5.36879 1.52513 6.02517C0.868749 6.68154 0.5 7.57178 0.5 8.50004V20.1667C0.5 21.095 0.868749 21.9852 1.52513 22.6416C2.1815 23.298 3.07174 23.6667 4 23.6667H13.3333C14.2616 23.6667 15.1518 23.298 15.8082 22.6416C16.4646 21.9852 16.8333 21.095 16.8333 20.1667V19H18C18.9283 19 19.8185 18.6313 20.4749 17.9749C21.1313 17.3185 21.5 16.4283 21.5 15.5V8.50004V8.43004ZM14.5 4.31171L17.5217 7.33337H15.6667C15.3572 7.33337 15.0605 7.21046 14.8417 6.99167C14.6229 6.77287 14.5 6.47613 14.5 6.16671V4.31171ZM14.5 20.1667C14.5 20.4761 14.3771 20.7729 14.1583 20.9917C13.9395 21.2105 13.6428 21.3334 13.3333 21.3334H4C3.69058 21.3334 3.39383 21.2105 3.17504 20.9917C2.95625 20.7729 2.83333 20.4761 2.83333 20.1667V8.50004C2.83333 8.19062 2.95625 7.89388 3.17504 7.67508C3.39383 7.45629 3.69058 7.33337 4 7.33337H5.16667V15.5C5.16667 16.4283 5.53542 17.3185 6.19179 17.9749C6.84817 18.6313 7.73841 19 8.66667 19H14.5V20.1667ZM19.1667 15.5C19.1667 15.8095 19.0438 16.1062 18.825 16.325C18.6062 16.5438 18.3094 16.6667 18 16.6667H8.66667C8.35725 16.6667 8.0605 16.5438 7.84171 16.325C7.62292 16.1062 7.5 15.8095 7.5 15.5V3.83337C7.5 3.52396 7.62292 3.22721 7.84171 3.00842C8.0605 2.78962 8.35725 2.66671 8.66667 2.66671H12.1667V6.16671C12.1667 7.09497 12.5354 7.9852 13.1918 8.64158C13.8482 9.29796 14.7384 9.66671 15.6667 9.66671H19.1667V15.5Z" fill="#9B9B9B" />
                                            </svg>
                                        }
                                    </span>
                                </div>
                                {this.state.copylinkflag ?
                                    <div className="mt_5">
                                        <p className="text_center copy_message">Link has been copied to clipboard</p>
                                    </div>
                                    :
                                    ''
                                }
                                <div className="mt_25 mb_25 text_center">
                                    <p>Do you want to send the invitation email to </p>
                                    <p> {this.state.userForResendMail.fname + ' ' + this.state.userForResendMail.lname} again?</p>
                                </div>
                            </div>
                            <div className="field_row text_center">
                                <button className="" onClick={this.CloseModal}>NO</button>
                                <button className="active" onClick={this.resendMail}>YES {this.state.emailLoader &&
                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* User History & Information Modal */}
                {this.state.userHistoryModal && this.state.selectedHistoryUser && (() => {
                    const u = this.state.selectedHistoryUser;
                    return (
                        <div className="user_popup active">
                            <span className="popup_overlay" onClick={this.closeUserHistoryModal}></span>
                            <div className="sundance_popup_detail box_shadow approve_success_popup user_history_popup bg_white">
                                <div className="approve_popup_header relative">
                                    <p>User History &amp; Information</p>
                                    <span className="close_popup" onClick={this.closeUserHistoryModal}>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="#FFFFFF" />
                                        </svg>
                                    </span>
                                </div>
                                <div className="content">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>Sundance ID</td>
                                                <td className="uh_break">{u._id || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>Eventive ID</td>
                                                <td>{u.eventiveId || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>Location</td>
                                                <td>{u?.loginLocation && u.loginLocation?.city +' , ' + u.loginLocation?.state + ' , ' + u.loginLocation?.country || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>Last Logged On (MT)</td>
                                                <td>{u.lastLogin ? moment(u.lastLogin).tz('US/Mountain').format('MM/DD/YYYY h:mm A') + ' MT' : '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>Last Password Changed At (MT)</td>
                                                <td>{u.lastForgotPassword ? moment(u.lastForgotPassword).tz('US/Mountain').format('MM/DD/YYYY h:mm A') + ' MT' : '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>Last Logged In Device / Browser</td>
                                                <td className="uh_break">{u.deviceType || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>User Agent</td>
                                                <td className="uh_break">{u.userAgent || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td>IP Address</td>
                                                <td className="uh_break">{u.userIP || '-'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    );
                })()}
            </React.Fragment>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(superAdminUserMgnt)